import React from "react";
import { StatusBadge } from "../../../../shared/components/badges/StatusBadge";
import { ExpandedAccordion } from "../../../../shared/components/ui/ExpandedAccordion";

const SupplierManagmentExpandRow = ({ item }) => {
  const sections = [
    {
      id: "supplier",
      title: "Supplier Information",
      fields: [
                { label: "Code", value: item.supplierCode || "—" },
        { label: "Email", value: item.email || "—" },
        { label: "Website", value: item.website || "—" },
        {
          label: "Rating",
          value: item.rating ? `${item.rating}/5 Stars` : "—",
        },
      ],
    },
    {
      id: "contact",
      title: "Contact & Address",
      fields: [
        { label: "Contact Person", value: item.supplierName || "—" },
        { label: "Phone", value: item.phone || "—" },
        { label: "Address", value: item.location || "—", isLong: true },
        { label: "City", value: item.city || "—" },
        { label: "State", value: item.state || "—" },
        { label: "Country", value: item.country || "—" },
      ],
    },
    {
      id: "legal",
      title: "Legal & Banking Details",
      fields: [
        { label: "License Number", value: item.licenseNumber || "—" },
        { label: "License Expiry Date", value: item.licenseExpiryDate || "—" },
      ],
    },
    {
      id: "financial",
      title: "Financial Summary",
      fields: [{ label: "Payment Terms", value: item.paymentTerms || "—" }],
    },
    {
      id: "vaccine",
      title: "Vaccine Details",
      fields: [
        { label: "Vaccine Type", value: item.vaccineType || "—" },
        
        
  
      ],
    },
  ];

  return <ExpandedAccordion sections={sections} />;
};

export default SupplierManagmentExpandRow;
